import TuneIcon from '@material-ui/icons/Tune';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const page = PageBlueprint.make({
  params: {
    path: '/configuracao/aplicacoes',
    routeRef: rootRouteRef,
    loader: () =>
      import('./RuntimeConfigPage').then(module => (
        <module.RuntimeConfigPage />
      )),
  },
});

export const runtimeConfigPlugin = createFrontendPlugin({
  pluginId: 'runtime-config',
  title: 'Configuração de Aplicações',
  icon: <TuneIcon />,
  routes: { root: rootRouteRef },
  extensions: [page],
});
